import { useTranslation } from "react-i18next";
import useQuestionResponse from "../../../Responses/useQuestionResponse";
import { useMemo } from "react";

export default function AverageScore() {
    const { i18n, t } = useTranslation();
    const { answers } = useQuestionResponse();

    const averageScore = useMemo(() => {
        const total = answers.reduce((sum, answer) => {
            const value = Number(answer.answerValue);
            return sum + (value >= 1 && value <= 5 ? value : 0);
        }, 0);
        const count = answers.length;
        return count > 0 ? total / count : 0;
    }, [answers]);

    return (
        <div className="flex flex-col items-center justify-between text-sm min-w-max w-30 gap-2">
            <div className="max-w-30 text-center">{t("responseOverview.averageScore")}</div>
            <div className="w-22 h-22 border-4 border-surface-teal-dark flex justify-center items-center bg-container rounded-full text-xl">
                {averageScore.toLocaleString(i18n.language, { maximumFractionDigits: 1 })}
            </div>
        </div>
    );
}
